export default {
  width: 32,
  height: 32,
  svg: `
    <path d="M27.963 7.055a1.018 1.018 0 00-1.018-1.019L7.998 6.035a1.018 1.018 0 00-1.018 1.018v6.927a1.018 1.018 0 01-2.036 0V7.053a3.054 3.054 0 013.054-3.054L26.945 4a3.055 3.055 0 013.054 3.055v13.032a3.054 3.054 0 01-3.054 3.055h-7.428a1.018 1.018 0 110-2.037h7.428a1.018 1.018 0 001.018-1.018V7.055z"/>
    <path d="M15.441 18.457a.61.61 0 00-.61-.611H4.648a.61.61 0 00-.611.61v6.924c0 .338.273.611.61.611H14.83a.61.61 0 00.611-.61v-6.924zm-.61-2.647a2.647 2.647 0 012.646 2.647v6.923a2.647 2.647 0 01-2.647 2.648H4.65A2.647 2.647 0 012 25.38v-6.923A2.647 2.647 0 014.65 15.81H14.83z"/>
  `
}
